<mat-label>
  <h2 class="center" mat-dialog-title>Recuperar tu Contraseña</h2>
</mat-label>

<div mat-dialog-actions>
  <form id="container" [formGroup]="formRestartPasword">
    <!-- [formGroup]="credentialsForm"  -->

    <!-- <mat-card class="mat-elevation-z8"> -->
    <div class="row gx-0">
      <div class="col-md-12">
        <div id="container-login">
          <!-- <mat-card-content> -->
          <mat-form-field class="email-input">
            <mat-label>Usuario: </mat-label>
            <input matInput name="username" placeholder="RFC - Número de Control" formControlName="username"
              type="text">
          </mat-form-field>
          <re-captcha [theme]="darkMode?'dark':'light'" #captcha [siteKey]="siteKey" (resolved)="resolved($event)"
            errorMode="handled"></re-captcha>
          <!-- <mat-card-actions class="actions-container"> -->
          <button mat-raised-button color="primary" type="submit" (click)="restartPassword()" class="mt-2"
            [disabled]="(!formRestartPasword.valid || robot)">

            <span>Enviar Correo de Recuperación</span>

          </button>


          <!-- </mat-card-actions> -->
          <!-- </mat-card-content> -->
        </div>

      </div>
    </div>
    <!-- </mat-card> -->
  </form>
</div>